// extracted by mini-css-extract-plugin
export default {"root":"AkGgu7","margin-top":"Ekm8ME","marginTop":"Ekm8ME","grid":"nr4eXB"};